var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudArrowUpFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0283 7.99651C17.6963 8.04651 12.0483 12.3565 10.5283 19.1225C6.64632 20.7545 4.02832 24.3845 4.02832 28.7465C4.02832 34.7665 8.78034 39.9965 14.6523 39.9965H34.0283C39.4963 39.9965 44.0283 36.0305 44.0283 30.9965C44.0283 27.3685 41.5263 24.2985 38.0283 22.8725C38.0323 22.5145 38.0283 22.0485 38.0283 21.9965C38.0883 14.3245 31.6103 7.93651 24.0283 7.99651ZM24.0283 15.9965L30.0523 21.9965H26.0283V29.9965C26.0283 31.1005 25.1323 31.9965 24.0283 31.9965C22.9243 31.9965 22.0283 31.1005 22.0283 29.9965V21.9965L18.0043 22.0045L24.0283 15.9965Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudArrowUpFill);
export default __webpack_public_path__ + "static/media/cloud-arrow-up-fill.6bae7e552b5b3924e952e1dab2f66ca1.svg";
export { ForwardRef as ReactComponent };